<template>
  <div class="wrap-statistic">
    <head-view :option="title" :subtitleOpt="subtitleOpt"></head-view>
    <b-loading :is-full-page="false" :active.sync="$store.state.isloader" :can-cancel="false"></b-loading>
    <div class="statistics-content">
      <div class="dp-stat">
        <!-- <date-picker v-model="dateSelect" class="data-picker-custom" range lang="es" format="DD MMM YYYY" confirm @confirm="changeDate" placeholder="Todas la fechas"></date-picker> -->
        <template>
          <div>
            <div class="datepicker-trigger">
              <input
                class="input-date"
                type="text"
                id="datepicker-trigger"
                placeholder="Seleccione las fechas"
                :value="formatDates(dateOne, dateTwo)">

                <AirbnbStyleDatepicker
                  :trigger-element-id="'datepicker-trigger'"
                  :mode="'range'"
                  :fullscreen-mobile="true"
                  :date-one="dateOne"
                  :date-two="dateTwo"
                  @date-one-selected="val => { dateOne = val }"
                  @date-two-selected="val => { dateTwo = val }"
                  @apply="changeDate"/>
            </div>
          </div>
        </template>
      </div>
      <h4 class="compare-title">Historial del punto de control en la Construcción</h4>
      
      <div class="content__chart" v-if="existBuildingsStats">
        <div id="apexBuildings" ref="bChart" class="charts"></div>
      </div>
      <!-- <div class="content has-text-grey has-text-centered" v-else>
													<p>
															<b-icon
																	icon="emoticon-sad"
																	size="is-large">
															</b-icon>
													</p>
													<p>No hay Histórico.</p>
			</div> -->
    </div>
    <div class="statistics-content--2">      
      <h4 class="compare-title">Histórico del punto de control del edificio</h4>
      <div class="content__table">
        <!-- <table-data :headers="headers" :width="width" source="statisticCP" :data="dataTable"></table-data> -->
        <div class="wrapper-select wrapper-select--footer">
          <div class="table-section">
						<b-table
						class="table-history"
            :data="buildingsStatTable?buildingsStatTable:[]"
            >
							<template slot-scope="props">
									<b-table-column field="date" label="Fecha" width="300" :custom-sort="dateSort">
											{{ props.row.date }}
									</b-table-column>
                  <b-table-column field="report" label="Mal" numeric>
                    <!-- {{props.row.report.filter(i => i.reportstatus == 'bad')[0]}} -->
											{{props.row.report.filter(i => i.reportstatus == 'bad')[0]?props.row.report.filter(i => i.reportstatus == 'bad')[0].count : 0}}
									</b-table-column>
                  <b-table-column field="report" label="Bien" numeric>
											{{props.row.report.filter(i => i.reportstatus == 'well')[0]?props.row.report.filter(i => i.reportstatus == 'well')[0].count : 0}}
									</b-table-column>
                  <b-table-column field="report" label="Pendiente" numeric>
											{{props.row.report.filter(i => i.reportstatus == 'pending')[0]?props.row.report.filter(i => i.reportstatus == 'pending')[0].count : 0}}
									</b-table-column>
                  <b-table-column field="report" label="Stand By" numeric>
											{{props.row.report.filter(i => i.reportstatus == 'standby')[0]?props.row.report.filter(i => i.reportstatus == 'standby')[0].count : 0}}
									</b-table-column>
              </template>

							<template slot="empty">
									<section class="section">
											<div class="content has-text-grey has-text-centered">
													<p>
															<b-icon
																	icon="emoticon-sad"
																	size="is-large">
															</b-icon>
													</p>
													<p>No hay datos en el rango de fechas seleccionadas.</p>
											</div>
									</section>
							</template>
        		</b-table>
					</div>
				</div>
      </div>
      <div class="content__chart">
        <div id="myChart" ref="apexChart2"></div>
      </div>
    </div>
  </div>
</template>

<script>
import headView from "../Componentes/headView";
import { mapState, mapGetters } from "vuex";
import ApexCharts from "apexcharts";
import format from "date-fns/format";
export default {
  name: "StatisticCheckpoint",
  components: {
    headView
  },
  data() {
    return {
      title: {
        headText: "Estadísticas: Puntos de Control",
        subtitle: ""
      },
      subtitleOpt: false,
      buildings: [],
      myChart: {},
      myChart2: {},
      chartsType: ["column", "area", "line"],
      dateSelect: "",
      dateFormat: "D MMM",
      dateOne: "",
      dateTwo: ""
    };
  },
  computed: {
    ...mapState([
      "currentCPStat",
      "currentCheckpointChart",
      "companyId",
      "currentCheckpointChartEdi",
      "buildingsChart",
      "buildingsStatList",
      "buildingsStatTable"
    ]),
    ...mapGetters([
      "getCPById",
      "edificios",
      "buildingsByCP",
      "reportByCP",
      "reportByBuild"
    ]),
    existBuildingsStats: function() {
      if (this.buildingsChart) {
        this.$nextTick(() => {
          this.bChart = new ApexCharts(this.$refs.bChart, this.buildingsChart);
          this.bChart.render();
          this.$store.commit("deactiveLoader")
        });
        return true;
      } else {
        return false;
      }
    },
    existCheckpointChartEdi: function() {
      if (this.buildings) {
        let obj = {
          edArr: this.buildings,
          datos: this.reportByBuild,
          chartsType: ["column"],
          rep: this.reportByBuild
        };
      }
      return false;
    }
  },
  created() {
    this.$store.commit("activeLoader")
    this.$store.dispatch("GETSTATCHECKPOINBUILDING", {
      checkpoint: this.$route.params.id,
      building: this.$route.params.fk
    });
  },
  beforeCreate() {
    this.$store.commit("setColorChildren", "statistics");
  },
  beforeDestroy() {
    this.$store.commit("activeLoader")
    this.$store.commit("resetColorChildren", "statistics");
  },
  methods: {
    changeDate: function() {
      //usa metodo post del api con campos startDate y endDate
      // console.log(new Date(this.dateOne.replace("-",".")).toISOString(), new Date(new Date(this.dateTwo.replace("-",".")).setHours(23,0,0,0)).toISOString())
      this.$store.commit("activeLoader")
      this.$store.dispatch("GETSTATCHECKPOINBUILDING", {
        checkpoint: this.$route.params.id,
        building: this.$route.params.fk,
        startDate: new Date(new Date(this.dateOne.replace("-",".")).setHours(-1,0,0,0)).toISOString(),
        endDate: new Date(new Date(this.dateTwo.replace("-",".")).setHours(23,0,0,0)).toISOString()
      });
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    dateSort(val1, val2, isAcc ){
      // console.log(val1, val2, isAcc);
      var date2 = val2.date.split('-')
      var date1 = val1.date.split('-')
      var aux = date2[0]
      date2[0] = date2[1]
      date2[1] = aux
      aux = date1[0]
      date1[0] = date1[1]
      date1[1] = aux
      if(isAcc){
        // console.log(new Date(date2.join('.')) , new Date(date1.join('.')));
        
        return new Date(date2.join('.')) - new Date(date1.join('.'))
      }else{
        return new Date(date1.join('.')) - new Date(date2.join('.'))
      }
    }
  }
};
</script>
<style lang="scss">
.asd__day {
  padding: 0.3em !important;
}
</style>
<style lang="scss" scoped>
.wrap-statistic {
  height: 100%;
}
.statistics-content {
  margin-top: 4em;
  padding: 2em;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  &--2 {
    margin-top: 1em;
    padding: 1em 2em;
  }
  .dp-stat {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 0 5rem;
  }
}
.charts {
  margin: auto;
}
.compare-title {
  text-align: left;
  margin-bottom: 10px;
}
.content__filters {
  display: flex;
  .filters__item {
    margin: 10px;
  }
}
#myChart {
  display: flex;
  justify-content: center;
}
.input-date {
  padding: 0.5rem 1rem;
  font-size: 0.8rem;
  border: thin solid #00a699;
}
</style>

<style>
.button-edit {
  border: thin solid #e6e4e6;
  padding: 1rem;
  color: #000000;
  font-weight: bold;
  margin: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/statisticCheckpointBuildingsHistoric.vue